type SharePriceLookUpProps = {
  standard: string;
};
export function SharePriceLookUp({ standard }: SharePriceLookUpProps) {
  return (
    <euroland-tool data-tool-name="SPLookup" data-tool-language={standard} />
  );
}
